import { LiveReviewDataSchema, type LiveReviewData } from "@common/schemas/live-review";
import { isStreamingJsonResult } from "@common/utils/isStreamingJsonResult";
import { parseJson } from "@common/utils/parseJson";

export type LiveReviewParseResult =
  | { status: "streaming" }
  | { status: "invalid" }
  | { status: "ready"; data: LiveReviewData };

/**
 * Parse a `live_review` tool-result payload into a render-ready state. Shared by
 * the web and Word chat renderers so the streaming / invalid / ready branches
 * stay identical across both.
 */
export function parseLiveReviewContent(content: string): LiveReviewParseResult {
  if (isStreamingJsonResult(content)) return { status: "streaming" };
  const trimmed = content.trim();
  const parsed = parseJson(trimmed) ?? parseLastConcatenatedSnapshot(trimmed);
  if (parsed === null) return { status: "invalid" };
  const result = LiveReviewDataSchema.safeParse(parsed);
  return result.success ? { status: "ready", data: result.data } : { status: "invalid" };
}

const CONCATENATED_SNAPSHOT_START = '{"issues":';

function parseLastConcatenatedSnapshot(text: string): unknown | null {
  const start = text.lastIndexOf(CONCATENATED_SNAPSHOT_START);
  if (start <= 0) return null;
  return parseJson(text.slice(start));
}
